import React, { useState, useEffect, useMemo, useRef, use  } from "react";
import { FaTrashAlt } from "react-icons/fa";
import axios from "axios";
import { useLocation } from "react-router-dom";
import config from "../config/config";
import { sharedData } from "../sharedData/sharedData";
import { useModal } from "./useModal";
import { UploadSuccess,UploadFailed,DocumentDeleted,DeletionFailed } from "../components/popups/rightSidebarPopup";
import { userSession } from '../observers/userObserver';
import { docTypeConfig, MULTI_FILE_DOC_TYPES } from "../config/docTypeConfig";
import { beneficiaryDocKeys } from "../config/trustDocRules";



export const useRightSidebar = ({compliantLetter,
    corporateStructureData,
    managementUboState,
    transactionStatus,
    eddFormData,
    landRegisterCopy,
    RegulatoryListed,
    BillingRecognized,
    setRefreshDocs,
    isPEP,
    InfluenceTransaction,
    IntermediaryName,
  }) => {
    const initialDocuments = {};

    // Last document set written to /save-updated-docs, so identical recomputes are skipped.
    const lastSavedDocsRef = useRef(null);
    // Value of the inputs the document builder last ran with.
    const lastInputsRef = useRef(null);
    const [modalHeading, setModalHeading] = useState("");
    const { modalOpen, modalMessage, setModalOpen, setModalMessage } = useModal();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [documents, setDocuments] = useState(initialDocuments);
    const location = useLocation();
    const currentPage  = location.pathname; // Derive pageKey from URL
    const [certifiedCheckbox, setCertifiedCheckbox] = useState(false);
    const [optionalAttachments, setOptionalAttachments] = useState({})
    const [optionalCount, setOptionalCount] = useState()
    const [uploadingToOptional, setUploadingToOptional] = useState(false);
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
    const [currentDocType, setCurrentDocType] = useState("");
    const [file, setFile] = useState(null);
    const [dragging, setDragging] = useState(false);
    const modalRef = useRef(null);
    const [fileName, setFileName] = useState("");
    const [requestStatus, setRequestStatus] = useState("");
    const [status, setStatus] = useState("");
    

    const getStoredValues = () => {
        try {
    
            // Retrieve values from sharedData
            let entityId = sharedData.get("entityId") || null;
            let requestId = sharedData.get("requestId") || null;
            const email = userSession.getUserEmail() || null; // Keeping email retrieval from localStorage
    
    
            return { entityId, requestId, email };
        } catch (error) {
            console.error("❌ Error retrieving stored values:", error);
            return { entityId: null, requestId: null, email: null };
        }
    };  
    
    useEffect(() => {
        const fetchOptionalAttachments = async () => {
          if (Object.keys(optionalAttachments).length > 0) {
            return; // Skip fetch if already loaded
          }
      
          try {
            const { requestId, email } = getStoredValues();
            const pageKey = currentPage.replace("/", "");



          const res = await fetch(
            `${config["backend-url"]}/get-optional?page=${pageKey}&requestId=${requestId}&email=${email}`, 
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${userSession.getToken()}`, // Use token from userSession
              }
            }
          );
      
            // const res = await fetch(`${config["backend-url"]}/get-optional?page=${pageKey}&requestId=${requestId}&email=${email}`);
            if (!res.ok) {
              throw new Error(`Failed to fetch optional attachments: ${res.status}`);
            }
      
            const data = await res.json();
            // console.log("res in fetch:",data)

            const safeData = data || {};
            setOptionalAttachments(prev => ({
              ...prev,
              ...safeData
            }));
      
            const maxCount = Object.keys(safeData)
              .map(k => parseInt(k.match(/Optional (\d+)/)?.[1] || 0))
              .reduce((a, b) => Math.max(a, b), 0);
      
            setOptionalCount(maxCount + 1);
          } catch (error) {
            console.error("Error fetching optional attachments:", error);
          }
        };
      
        fetchOptionalAttachments();
      }, [currentPage]);

    const addOptionalAttachment = async () => {
        try {
        const { requestId, email } = getStoredValues();
        const pageKey = currentPage.replace("/", "");
        const documentType = `Optional ${optionalCount}`;
        const newDocKey = `${pageKey}-${documentType}`;
        console.log("newDocKey in save:",newDocKey,email)
        const res = await fetch(`${config["backend-url"]}/save-optional`, {
            method: 'POST',
            headers: {
            "Authorization": `Bearer ${userSession.getToken()}`, // Use token from userSession
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
            page: pageKey,
            document_type: newDocKey,
            requestId: requestId,
            email: email
            })
        });
    
        if (!res.ok) {
            throw new Error(`Failed to save optional attachment: ${res.status}`);
        }
    
        setOptionalAttachments(prev => ({
            ...prev,
            [newDocKey]: null
        }));
        setOptionalCount(prev => prev + 1);
        } catch (error) {
        console.error("Error saving optional attachment:", error);
        }
    };

    
    const handleDeleteOptionalAttachment = async (document_type) => {
        const { requestId, email } = getStoredValues(); // ✅ Get extra values
        const page = currentPage.replace("/", "");
        try {
        const response = await fetch(`${config["backend-url"]}/delete-optional-attachment`, {
            method: 'POST',
            headers: {
            "Authorization": `Bearer ${userSession.getToken()}`, // Use token from userSession
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
            requestId,
            email,
            page,
            document_type,
            }),
        });

        const data = await response.json();

        if (response.ok) {
            // Remove from UI
            const updatedAttachments = { ...optionalAttachments };
            delete updatedAttachments[document_type];
            setOptionalAttachments(updatedAttachments);
        } else {
            console.error('Delete failed:', data.message);
            setModalMessage(<DeletionFailed/>);
            setIsModalOpen(true);
        }
        } catch (error) {
        console.error('Error deleting optional attachment:', error);
        setModalMessage(<DeletionFailed/>);
        setIsModalOpen(true);
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setPreviewModalOpen(false);
        }
        };

        if (previewModalOpen) {
        document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [previewModalOpen]);


    const fetchRequestStatus = async () => {
      try {
        const request_id = JSON.parse(localStorage.getItem("sharedData"))?.requestId;
        if (!request_id) {
          console.error("❌ Missing request_id in sharedData");
          return null;
        }

        const statusTypeResp = await fetch(`${config["backend-url"]}/get-request-status-type`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${userSession.getToken()}`
          },
          body: JSON.stringify({ request_id })
        });

        if (!statusTypeResp.ok) {
          throw new Error("Failed to fetch request status");
        }

        const responseJson = await statusTypeResp.json();
        const statusValue = responseJson?.Request_Status?.toLowerCase();
        // console.log("✅ Live status fetched:", statusValue);

        if (statusValue) {
          setStatus(statusValue);
          setRequestStatus(responseJson);
          return statusValue;
        } else {
          console.warn("⚠️ Status missing in API response", responseJson);
          return null;
        }
      } catch (error) {
        console.error("❌ Error fetching status:", error);
        return null;
      }
    };

    useEffect(() => {
      fetchRequestStatus(); // initial fetch
    }, []);

    // Open upload modal
    const openUploadModal = async (docType, isOptional = false) => {
        const latestStatus = await fetchRequestStatus();
        if (!latestStatus) {
          console.warn("⚠️ Could not determine status. Blocking upload.");
          return;
        }

        if (["complete", "finalized", "deleted"].includes(latestStatus)) {
          console.warn("⛔ Upload is disabled. Status:", latestStatus);
          return;
        }
        // setModalMessage(null);
        setCertifiedCheckbox(false); // ✅ Reset checkbox every time
        setCurrentDocType(docType);
        setUploadModalOpen(true);
        setUploadingToOptional(isOptional);
        setFileName("");         // ✅ Reset previous file name
        setFile(null);
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
          setFile(selectedFile);
        }
      };
    
    // Handle drag events
    const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
    };
    
    const handleDragLeave = () => {
    setDragging(false);
    };

    const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
        setFile(droppedFile);
    }
    };
      
    
    const [fileDescriptions, setFileDescriptions] = useState({});
    const handleDescriptionChange = (docType, event) => {
    setFileDescriptions({
        ...fileDescriptions,
        [docType]: event.target.value,
    });
    };

    const handleFileUpload = async () => {
        if (!file) {
            setModalMessage("Please select a file before submitting.");
            setModalOpen(true);
            return;
        }
        // console.log("✅ certifiedCheckbox:", certifiedCheckbox ? "true" : "false");
        
        const { entityId, requestId, email } = getStoredValues();
        
        let pageForUpload = currentPage;
        let cleanedDocType = currentDocType;
        let tempDocType = cleanedDocType;      // For matching only

        // Utility to strip entity prefixes like "Ubo 1 -", "Manager 2 -", etc.
        // const stripEntityPrefix = (docType) => {
        //   const entityPrefixes = ["UBO", "Manager"];
        //   for (let prefix of entityPrefixes) {
        //     const regex = new RegExp(`^${prefix} \\d+ - `, 'i');
        //     if (regex.test(docType)) {
        //       return docType.replace(regex, '');
        //     }
        //   }
        //   return docType;
        // };
        
        // ✅ Enhanced utility to strip up to two entity-level prefixes
        const stripEntityPrefix = (docType) => {
          const entityPrefixPattern = /^(UBO|Manager)( \d+)?( - Director \d+)? - /i;
          return docType.replace(entityPrefixPattern, '').trim();
        };
        // // ✅ Clean tempDocType only for matching
        tempDocType = stripEntityPrefix(tempDocType);
        // // Utility to check for UBO or Manager
        // const getEntityFlags = (docType) => {
        //   const isUBO = /^UBO( \d+)? - /i.test(docType);         // Matches "UBO 1 - ..." or "UBO - ..."
        //   const isManager = /^Manager( \d+)? - /i.test(docType); // Matches "Manager 2 - ..." or "Manager - ..."
        //   return { isUBO, isManager };
        // };


        // ✅ Enhanced entity detection logic
        const getEntityFlags = (docType) => {
          const isUBO = /^UBO( \d+)?( - Director \d+)? - /i.test(docType);
          const isManager = /^Manager( \d+)?( - Director \d+)? - /i.test(docType);
          return { isUBO, isManager };
        };
        
        const { isUBO, isManager } = getEntityFlags(currentDocType); // Use currentDocType with entity prefix

        if (currentPage === "/FinalReview" && uploadingToOptional === false) {
            // const pageNameList = [
            // "/transaction-detail", "/property-info", "/client-counter",
            // "/corporate-structure", "/management-structure", "/RiskAsses",
            // "/Edd", "/FinalReview", "/Report"
            // ];
        
            // for (const pageName of pageNameList) {
            // const pageKey = pageName.substring(1);
            // if (currentDocType.startsWith(`${pageKey}-`)) {
            //     pageForUpload = `/${pageKey}`;
            //     cleanedDocType = currentDocType.replace(`${pageKey}-`, "");
            //     break;
            // }
            // }
            let matchedPage = null;

            // First check for exact match in docTypeConfig
            for (const [page, docTypes] of Object.entries(docTypeConfig)) {
              if (docTypes.includes(tempDocType)) {
                matchedPage = page;

                // ✅ Override based on entity type if conflict is possible
                if (isUBO) {
                  pageForUpload = "/corporate-structure";
                  // console.log("📌 Forced match (UBO):", pageForUpload);
                  break;
                }
                if (isManager) {
                  pageForUpload = "/management-structure";
                  // console.log("📌 Forced match (Manager):", pageForUpload);
                  break;
                }

                // ✅ If no override needed, default to first matched page
                pageForUpload = matchedPage;
                console.log("✅ Matched from config:", pageForUpload);
                break;
              }
            }
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("document_type", cleanedDocType);
        formData.append("description", fileDescriptions[currentDocType] || "");
        formData.append("page_name", pageForUpload);
        formData.append("entityId", entityId);
        formData.append("requestId", requestId);
        formData.append("email", email);
        formData.append("certified", certifiedCheckbox ? "true" : "false");
        formData.append("is_optional", uploadingToOptional ? "true" : "false");
    
        
        try {
            const response = await axios.post(`${config['backend-url']}/upload`, formData, {
            headers: { 
              "Authorization": `Bearer ${userSession.getToken()}`, // Use token from userSession
              
              "Content-Type": "multipart/form-data" },
            });
        
            if (response.status === 200) {
            console.log("✅ Upload success:", pageForUpload, response.data);
            
            if (uploadingToOptional) {
                // 🧹 Remove from required documents
                setDocuments((prevDocs) => {
                const updatedDocs = { ...prevDocs };
                delete updatedDocs[currentDocType];
                return updatedDocs;
                });
            
                // 📥 Add to optionalAttachments
                setOptionalAttachments((prevDocs) => ({
                ...prevDocs,
                [currentDocType]: {
                    filename: response.data.filename,
                    file: response.data.blob_url,
                    description: fileDescriptions[currentDocType] || "",
                    entityId: response.data.entityId,
                    requestId: response.data.requestId,
                    email: response.data.email,
                    certified: certifiedCheckbox,
                },
                }));
            } else {
                // 🧹 Remove from optional attachments
                setOptionalAttachments((prevDocs) => {
                const updatedDocs = { ...prevDocs };
                delete updatedDocs[currentDocType];
                return updatedDocs;
                });
            
                // 📥 Add to required documents
                setDocuments((prevDocs) => {
                  const newFile = {
                    filename: response.data.filename,
                    file: response.data.blob_url,
                    description: fileDescriptions[currentDocType] || "",
                    entityId: response.data.entityId,
                    requestId: response.data.requestId,
                    email: response.data.email,
                    certified: certifiedCheckbox,
                  };
                  if (MULTI_FILE_DOC_TYPES.includes(currentDocType)) {
                    const existing = Array.isArray(prevDocs[currentDocType]) ? prevDocs[currentDocType] : [];
                    return { ...prevDocs, [currentDocType]: [...existing, newFile] };
                  }
                  return { ...prevDocs, [currentDocType]: newFile };
                });
            }
            setUploadModalOpen(false);
            setModalMessage(<UploadSuccess />);
            setIsModalOpen(true);
            setFile(null);
            setCertifiedCheckbox(false);
            setFileDescriptions((prev) => ({ ...prev, [currentDocType]: "" }));
            
            if (typeof setRefreshDocs === 'function') {
                setRefreshDocs(prev => !prev);
            } else {
                console.warn("⚠️ setRefreshDocs is not a function");
            }
            }
        } catch (error) {
            console.error("❌ Upload error:", error);
            setModalMessage(<UploadFailed />);
            setIsModalOpen(true);
            setModalOpen(true);
        }
        };


    const uboTypeDocuments = {
        "Private Individual (Natural Person)": ["Certified copy of passport/other ID", "Proof of address"],
        "Private Company": ["Certificate of Incorporation or Equivalent Incorporation Document", "Memorandum & Articles of Association", "Last filed accounts", "UBO Screen Shot of PSC Register", "Evidence of the company Officers", "Evidence of the register of Persons with Significant Control"],
        "Partnership": ["Partnership Deed", "Certificate of Incorporation of a Partnership", "Last filed accounts", "Evidence of the list of Partners (PSC register)"],
        // "Company Listed on a Recognised Stock Exchange": ["Evidence of listing on a recognised stock exchange"],
        "Regulated Entity": ["Evidence of regulated status"],
        // "Pension Fund": ["Evidence of registration with Pensions Regulator(if applicable)", "Evidence of registration with HMRC as a recognised pension fund(if applicable)"],
        "Foundations": ["Certified copy of the foundation’s formation documents", "Official records confirming its registration (corporate registry extract)"],
        "Public Sector Bodies, governments, state owned companies and local authorities.": ["Website printout evidencing the full name of the entity, the nature and status and the name of its home-state authority"],
        // Trust docs are NOT unconditional — they depend on the trustee type and the
        // trust type, so they are added per-UBO below (see BENEFICIARY_ID_TRUST_TYPES):
        //  - Trustee ID: trusteeTypeDocuments already asks the right thing for each of
        //    Corporate Trustee / Legal Person / Natural Person. A blanket "passports for
        //    the Trustees" wrongly asked a corporate trustee for a passport.
        //  - Beneficiary ID/POA: only possible where beneficiaries are named. Discretionary
        //    (and other class-based) trusts have no named beneficiaries to identify.
        "Trust": [],
        "Charities": ["Evidence that the Charity is recognised by the home state authority"],
        "Church bodies": ["Evidence that the Church Body or Place of Worship is recognised by the home state authority"],
        "Unit Trust": [
          "Certified copy structure chart for Unit Trust",
          "Certified Copy Trust Deed",
          "Certified Copy Nominee Agreement evidencing Trustee of the Unit Trust owning and controlling the Nominee Companies",
          "Certified copy identification documents for Trustees (corporate information, directors identification documents and proof of address)"
        ],
    
        // Add more UBO types as needed
      };
    
    const trusteeTypeDocuments = {
        "Corporate Trustee": ["Certificate of Incorporation", "Evidence of regulated status (if applicable)",
            "Certified register of directors AND Certified copy passports for the directors"
        ],
        "Legal Person": ["Certificate of Incorporation", "Certified register of directors", "Certified copy passports for the directors"],
        "Natural Person": ["Proof of address", "Certified Copy Passport"]
    };

    const updateDocumentsForType = (prevDocs, typeDocuments, applicableTypes, prefix) => {
        let updatedDocs = { ...prevDocs };
        
        // ✅ Add necessary documents for applicable types
        applicableTypes.forEach((type) => {
          if (typeDocuments[type]) {
            typeDocuments[type].forEach((doc) => {
              const key = prefix ? `${prefix} - ${doc}` : doc;
              updatedDocs[key] = prevDocs[key] || null;
            });
          }
        });
      
        return updatedDocs;
      };
      
    useEffect(() => {
        // These dependencies are objects rebuilt by their owners, so React's identity
        // check re-runs this effect even when nothing actually changed. Compare by value
        // instead — an upstream render loop then costs nothing instead of thousands of
        // get-required / documents / save-updated-docs calls.
        try {
          const signature = JSON.stringify([
            compliantLetter, corporateStructureData, managementUboState, landRegisterCopy,
            BillingRecognized, RegulatoryListed, transactionStatus, eddFormData, isPEP,
            InfluenceTransaction, location.pathname,
          ]);
          if (lastInputsRef.current === signature) return;
          lastInputsRef.current = signature;
        } catch (err) {
          // Unserialisable input (circular reference): fall through and run as before.
        }

        const fetchAndUpdateDocs = async () => {
        const { requestId, email } = getStoredValues(); // adjust this function if needed
        const currentPage = location.pathname.replace("/", "")

        let requiredDocs = {};
        try {
          const res = await fetch(
            `${config["backend-url"]}/get-required?page=${currentPage}&requestId=${requestId}&email=${email}`,
          
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${userSession.getToken()}`, // Use token from userSession
              }
            }
          
          
          );
          if (res.ok) {
            requiredDocs = await res.json();
          } else {
            console.warn("Failed to fetch required docs");
          }
        } catch (err) {
          console.error("Error fetching required docs:", err);
        }
        console.log("fetched requiredDocs:",currentPage,requiredDocs)

        setDocuments((prevDocs) => {
          let updatedDocs = { ...requiredDocs, ...prevDocs };
          
          if (location.pathname !== "/FinalReview") {
            // Standard updates
    
            if (transactionStatus === "Validated" && location.pathname === "/transaction-detail") {
              updatedDocs["Heads of Terms(Optional)"] = prevDocs["Heads of Terms(Optional)"] || null;
            } else {
              delete updatedDocs["Heads of Terms(Optional)"];
            }
      
            if (compliantLetter === "Yes" && location.pathname === "/client-counter") {
              updatedDocs["Letter of Reliance"] = prevDocs["Letter of Reliance"] || null;
            } else {
              delete updatedDocs["Letter of Reliance"];
            }
    
            if (RegulatoryListed === "Yes" && location.pathname === "/client-counter") {
              updatedDocs["Proof of Regulated Status"] = prevDocs["Proof of Regulated Status"] || null;
            } else {
              delete updatedDocs["Proof of Regulated Status"];
            }
    
            if (BillingRecognized === "Yes" && location.pathname === "/client-counter") {
              updatedDocs["Proof of Listing on a Recognised Exchange"] = prevDocs["Proof of Listing on a Recognised Exchange"] || null;
            } else {
              delete updatedDocs["Proof of Listing on a Recognised Exchange"];
            }
    
            if (landRegisterCopy === "Yes" && location.pathname === "/client-counter") {
              updatedDocs["Official Copy/Dastcha"] = prevDocs["Official Copy/Dastcha"] || null;
            } else {
              delete updatedDocs["Official Copy/Dastcha"];
            }
    
    
            // EDD Document
            if (eddFormData?.MortgageOnProperty === "Yes") {
              updatedDocs["Official Copy of the Charges Register"] = prevDocs["Official Copy of the Charges Register"] || null;
            } else {
              delete updatedDocs["Official Copy of the Charges Register"];
            }
            
            if (isPEP === "Yes" && location.pathname === "/RiskAsses") {
              updatedDocs["Electronic Screening Report(s)"] = prevDocs["Electronic Screening Report(s)"] || [];
            } else {
              delete updatedDocs["Electronic Screening Report(s)"];
            }


            if (InfluenceTransaction === "Yes" && location.pathname === "/RiskAsses") {
              updatedDocs["Intermediary - ID Document"] = prevDocs["Intermediary - ID Document"] || null;
              updatedDocs["Intermediary - Electronic screening"] = prevDocs["Intermediary - Electronic screening"] || null;
            } else {
              delete updatedDocs["Intermediary - ID Document"];
              delete updatedDocs["Intermediary - Electronic screening"];
            }

            
            // if (InfluenceTransaction === "Yes" && location.pathname === "/RiskAsses") {
            //   updatedDocs["Intermediary - Electronic screening"] = prevDocs["Intermediary - Electronic screening"] || null;
            // } else {
            //   delete updatedDocs["Intermediary - Electronic screening"];
            // }
    
            // get the required docs from /Corporate-Structure
            if (location.pathname === "/Corporate-Structure" || location.pathname === "/corporate-structure") {
    
    
              // Remove stale UBO docs (for deleted UBOs)
              const allUboPrefixesInDocs = new Set(
                Object.keys(updatedDocs)
                  .filter((key) => key.startsWith("UBO "))
                  .map((key) => key.split(" -")[0])
              );
    
              const storedCorporateData = localStorage.getItem("corporateFormData");
              console.log("local:",storedCorporateData)
              const parsedCorporateData = storedCorporateData ? JSON.parse(storedCorporateData) : {};
              const parsedUbos = parsedCorporateData?.ubos || [];
    
              const currentUboPrefixes = new Set(
                parsedUbos.map((_, index) => `UBO ${index + 1}`)
              );
            
              allUboPrefixesInDocs.forEach((prefix) => {
                if (!currentUboPrefixes.has(prefix)) {
                  Object.keys(updatedDocs).forEach((key) => {
                    if (key.startsWith(`${prefix} -`)) {
                      delete updatedDocs[key];
                    }
                  });
                }
              });
            
              // 💡 Reset to build fresh UBO docs
              updatedDocs = {};
            
              // 👇 Now build the updatedDocs from active UBOs
              parsedUbos.forEach((ubo, index) => {
                const prefix = `UBO ${index + 1}`;
                const uboType = ubo?.type;
                const uboData = ubo?.data || {};
            
                const perUboDocs = {};
    
                if (uboData?.uboIsPensionFundRegistered === "Yes" && uboType === "Pension Fund") {
                  perUboDocs[`${prefix} - Evidence of registration with Pensions Regulator(if applicable)`] =
                    prevDocs[`${prefix} - Evidence of registration with Pensions Regulator(if applicable)`] || null;
                }
    
                if (uboData?.uboIsPensionFundRegisteredWithHMRC === "Yes" && uboType === "Pension Fund") {
                  perUboDocs[`${prefix} - Evidence of registration with HMRC as a recognised pension fund(if applicable)`] =
                    prevDocs[`${prefix} - Evidence of registration with HMRC as a recognised pension fund(if applicable)`] || null;
                }
    
                if (uboData?.uboIsMember === "Yes" && uboType === "Sovereign Wealth Funds") {
                  perUboDocs[`${prefix} - Screenshot of International Working Group of Sovereign Wealth Funds membership`] =
                    prevDocs[`${prefix} - Screenshot of International Working Group of Sovereign Wealth Funds membership`] || null;
                }
            
                if (uboData?.uboRegulatedFund === "Yes" && uboType === "Fund") {
                  perUboDocs[`${prefix} - Evidence of the Funds regulated status`] =
                    prevDocs[`${prefix} - Evidence of the Funds regulated status`] || null;
                }
            
                if (uboData?.uboIsRegulatedFundManager === "Yes" && uboType === "Fund") {
                  perUboDocs[`${prefix} - Evidence of the Fund Manager’s regulated status`] =
                    prevDocs[`${prefix} - Evidence of the Fund Manager’s regulated status`] || null;
                }
            
                if (uboData?.uboCoporateTrusteeRegulatedTrustCompany === "Yes" && uboType === "Trust") {
                  perUboDocs[`${prefix} - Proof of Trustee Regulation`] =
                    prevDocs[`${prefix} - Proof of Trustee Regulation`] || null;
                }

                if (uboData?.uboTrustDeedObtained === "Yes" && uboType === "Trust") {
                  perUboDocs[`${prefix} - Certified copy Trust Deed`] =
                    prevDocs[`${prefix} - Certified copy Trust Deed`] || null;
                }

                if (uboData?.uboHasUnitHolder === "Yes" && uboType === "Unit Trust") {
                  perUboDocs[`${prefix} - ID Documents for Unit Holders`] =
                    prevDocs[`${prefix} - ID Documents for Unit Holders`] || null;
                }

                if (uboData?.uboTrustProtectorOrController === "Yes" && uboType === "Trust") {
                  perUboDocs[`${prefix} - Protector/Controller ID document`] =
                    prevDocs[`${prefix} - Protector/Controller ID document`] || null;
                }

                beneficiaryDocKeys(prefix, uboType, uboData).forEach((key) => {
                  perUboDocs[key] = prevDocs[key] || null;
                });

                if (
                  uboType === "Trust" &&
                  uboData?.uboTrusteeType === "Corporate Trustee" &&
                  Array.isArray(uboData?.uboDirectors)
                ) {
                  uboData.uboDirectors.forEach((directorName, index) => {
                    if (directorName && directorName.trim() !== "") {
                      const directorPrefix = `${prefix} - Director ${index + 1}`;
                      const idKey = `${directorPrefix} - Trust company director ID`;
                      const addressKey = `${directorPrefix} - Trust company director proof of address`;

                      perUboDocs[idKey] = prevDocs[idKey] || null;
                      perUboDocs[addressKey] = prevDocs[addressKey] || null;
                    }
                  });
                }
    
                if (uboData?.uboSettlorType === "Corporate Entity" && uboType === "Trust") {
                  perUboDocs[`${prefix} - Settlor ID`] =
                    prevDocs[`${prefix} - Settlor ID`] || null;
                }
    
                if (uboData?.uboIndividualSettlorType === "No" && uboType === "Trust") {
                  perUboDocs[`${prefix} - Settlor ID (Passport or equivalent document)`] =
                    prevDocs[`${prefix} - Settlor ID (Passport or equivalent document)`] || null;
                }
            
                if (
                  ubo?.type === "Private Individual (Natural Person)"
                ) {
                  perUboDocs[`${prefix} - Certified copy of passport/other ID`] =
                    prevDocs[`${prefix} - Certified copy of passport/other ID`] || null;
            
                  perUboDocs[`${prefix} - Proof of address`] =
                    prevDocs[`${prefix} - Proof of address`] || null;
                }

                if (uboData?.uboRecognisedExchange === "Yes" && uboType === "Private Company") {
                  perUboDocs[`${prefix} - UBO Certificate of Incorporation`] =
                    prevDocs[`${prefix} - UBO Certificate of Incorporation`] || null;
                }

                if (uboData?.uboRecognisedExchange === "Yes" && uboType === "Partnership") {
                  perUboDocs[`${prefix} - UBO Certificate of Incorporation`] =
                    prevDocs[`${prefix} - UBO Certificate of Incorporation`] || null;
                }

                if (uboData?.uboRecognisedExchange === "Yes" && uboType === "Company Listed on a Recognised Stock Exchange") {
                  perUboDocs[`${prefix} - UBO Certificate of Incorporation`] =
                    prevDocs[`${prefix} - UBO Certificate of Incorporation`] || null;
                }
            
                const uboDocs = updateDocumentsForType({}, uboTypeDocuments, [uboType], prefix);
                const trusteeDocs = updateDocumentsForType({}, trusteeTypeDocuments, [uboData?.uboTrusteeType || ""], prefix);
            
                Object.assign(updatedDocs, perUboDocs, uboDocs, trusteeDocs);
              });
            }
            
    
    
            // get the required data from management structure page
            if (location.pathname === "/management-structure") {
              // Remove stale manager docs (for deleted managers)
              const allManagerPrefixesInDocs = new Set(
                Object.keys(updatedDocs)
                  .filter((key) => key.startsWith("Manager "))
                  .map((key) => key.split(" -")[0])
              );
              console.log("localStorage:",localStorage)

              const storedManagers = localStorage.getItem("managers");
              const parsedManagers = storedManagers ? JSON.parse(storedManagers) : [];
            
              const currentManagerPrefixes = new Set(
                parsedManagers.map((_, index) => `Manager ${index + 1}`)
              );
            
              allManagerPrefixesInDocs.forEach((prefix) => {
                if (!currentManagerPrefixes.has(prefix)) {
                  Object.keys(updatedDocs).forEach((key) => {
                    if (key.startsWith(`${prefix} -`)) {
                      delete updatedDocs[key];
                    }
                  });
                }
              });
            
              // 💡 Reset to build fresh manager docs
              updatedDocs = {};
            
              // 👇 Now build the updatedDocs from active managers
              parsedManagers.forEach((manager, index) => {
                const prefix = `Manager ${index + 1}`;
                const ubo = manager?.data?.uboState;
                const uboType = ubo?.type;
                const uboData = ubo?.data || {};
                const trusteeType = uboData?.uboTrusteeType || "";
            
                const perManagerDocs = {};
    
                if (uboData?.uboIsPensionFundRegistered === "Yes" && uboType === "Pension Fund") {
                  perManagerDocs[`${prefix} - Evidence of registration with Pensions Regulator(if applicable)`] =
                    prevDocs[`${prefix} - Evidence of registration with Pensions Regulator(if applicable)`] || null;
                }
    
                if (uboData?.uboIsPensionFundRegisteredWithHMRC === "Yes" && uboType === "Pension Fund") {
                  perManagerDocs[`${prefix} - Evidence of registration with HMRC as a recognised pension fund(if applicable)`] =
                    prevDocs[`${prefix} - Evidence of registration with HMRC as a recognised pension fund(if applicable)`] || null;
                }
            
                if (uboData?.uboIsMember === "Yes" && uboType === "Sovereign Wealth Funds") {
                  perManagerDocs[`${prefix} - Screenshot of International Working Group of Sovereign Wealth Funds membership`] =
                    prevDocs[`${prefix} - Screenshot of International Working Group of Sovereign Wealth Funds membership`] || null;
                }
            
                if (uboData?.uboRegulatedFund === "Yes" && uboType === "Fund") {
                  perManagerDocs[`${prefix} - Evidence of the Funds regulated status`] =
                    prevDocs[`${prefix} - Evidence of the Funds regulated status`] || null;
                }
            
                if (uboData?.uboIsRegulatedFundManager === "Yes" && uboType === "Fund") {
                  perManagerDocs[`${prefix} - Evidence of the Fund Manager’s regulated status`] =
                    prevDocs[`${prefix} - Evidence of the Fund Manager’s regulated status`] || null;
                }
            
                if (uboData?.uboCoporateTrusteeRegulatedTrustCompany === "Yes" && uboType === "Trust") {
                  perManagerDocs[`${prefix} - Proof of Trustee Regulation`] =
                    prevDocs[`${prefix} - Proof of Trustee Regulation`] || null;
                }

                if (uboData?.uboTrustDeedObtained === "Yes" && uboType === "Trust") {
                  perManagerDocs[`${prefix} - Certified copy Trust Deed`] =
                    prevDocs[`${prefix} - Certified copy Trust Deed`] || null;
                }

                if (uboData?.uboHasUnitHolder === "Yes" && uboType === "Unit Trust") {
                  perManagerDocs[`${prefix} - ID Documents for Unit Holders`] =
                    prevDocs[`${prefix} - ID Documents for Unit Holders`] || null;
                }

                if (uboData?.uboTrustProtectorOrController === "Yes" && uboType === "Trust") {
                  perManagerDocs[`${prefix} - Protector/Controller ID document`] =
                    prevDocs[`${prefix} - Protector/Controller ID document`] || null;
                }

                beneficiaryDocKeys(prefix, uboType, uboData).forEach((key) => {
                  perManagerDocs[key] = prevDocs[key] || null;
                });

                if (
                    uboType === "Trust" &&
                    uboData?.uboTrusteeType === "Corporate Trustee" &&
                    Array.isArray(uboData?.uboDirectors)
                  ) {
                    uboData.uboDirectors.forEach((directorName, index) => {
                      if (directorName && directorName.trim() !== "") {
                        const directorPrefix = `${prefix} - Director ${index + 1}`;
                        const idKey = `${directorPrefix} - Trust company director ID`;
                        const addressKey = `${directorPrefix} - Trust company director proof of address`;

                        perManagerDocs[idKey] = prevDocs[idKey] || null;
                        perManagerDocs[addressKey] = prevDocs[addressKey] || null;
                      }
                    });
                  }
    
                if (uboData?.uboSettlorType === "Corporate Entity" && uboType === "Trust") {
                    perManagerDocs[`${prefix} - Settlor ID`] =
                    prevDocs[`${prefix} - Settlor ID`] || null;
                }
    
                if (uboData?.uboIndividualSettlorType === "No" && uboType === "Trust") {
                  perManagerDocs[`${prefix} - Settlor ID (Passport or equivalent document)`] =
                    prevDocs[`${prefix} - Settlor ID (Passport or equivalent document)`] || null;
                }

                if (uboData?.uboRecognisedExchange === "Yes" && uboType === "Private Company") {
                  perManagerDocs[`${prefix} - UBO Certificate of Incorporation`] =
                    prevDocs[`${prefix} - UBO Certificate of Incorporation`] || null;
                }
                if (uboData?.uboRecognisedExchange === "Yes" && uboType === "Partnership") {
                  perManagerDocs[`${prefix} - UBO Certificate of Incorporation`] =
                    prevDocs[`${prefix} - UBO Certificate of Incorporation`] || null;
                }
                if (uboData?.uboRecognisedExchange === "Yes" && uboType === "Company Listed on a Recognised Stock Exchange") {
                  perManagerDocs[`${prefix} - UBO Certificate of Incorporation`] =
                    prevDocs[`${prefix} - UBO Certificate of Incorporation`] || null;
                }
            
                if (
                  manager?.managerEntity === "Individual" ||
                  uboType === "Private Individual (Natural Person)"
                ) {
                  perManagerDocs[`${prefix} - Certified copy of passport/other ID`] =
                    prevDocs[`${prefix} - Certified copy of passport/other ID`] || null;
            
                  perManagerDocs[`${prefix} - Proof of address`] =
                    prevDocs[`${prefix} - Proof of address`] || null;
                }
            
                const uboDocs = updateDocumentsForType({}, uboTypeDocuments, [uboType], prefix);
                const trusteeDocs = updateDocumentsForType({}, trusteeTypeDocuments, [trusteeType], prefix);
            
                Object.assign(updatedDocs, perManagerDocs, uboDocs, trusteeDocs);
              });
            }
            
            // })
    
            if (corporateStructureData?.certifiedStructureChart === "Yes") {
      
              updatedDocs["Entity Structure Chart"] = prevDocs["Entity Structure Chart"] || null;
            } else {
              delete updatedDocs["Entity Structure Chart"];
            }
      
            if (corporateStructureData?.isUboIdentified === "Yes") {
              updatedDocs["Screenshot of PSC Register"] = prevDocs["Screenshot of PSC Register"] || null;
            } else {
              delete updatedDocs["Screenshot of PSC Register"];
            }
    
            const pageKey = `updatedDocs-${location.pathname}`;
            const serialisedDocs = JSON.stringify(updatedDocs);

            // Nothing changed since the last run: don't write, don't save. Without this
            // a render loop upstream turns into thousands of /save-updated-docs calls.
            if (lastSavedDocsRef.current === serialisedDocs) {
              return updatedDocs;
            }
            lastSavedDocsRef.current = serialisedDocs;

            localStorage.setItem(pageKey, serialisedDocs);
            // console.log("localStorage",localStorage)

            // 🔄 Call the API to save updatedDocs
            const { requestId, email } = getStoredValues();
            const cleanedPageKey = location.pathname.replace("/", ""); // remove leading slash
            // console.log("email in session:",email)

            fetch(`${config["backend-url"]}/save-updated-docs`, {
              method: 'POST',
              headers: { 
              "Authorization": `Bearer ${userSession.getToken()}`, // Use token from userSession
                
                
                'Content-Type': 'application/json' },
              body: JSON.stringify({
                page: cleanedPageKey,
                updated_docs: JSON.parse(serialisedDocs),
                requestId: requestId,
                email: email
              })
            })
              .then(res => res.json())
              .then(data => console.log("Updated docs saved:", updatedDocs,cleanedPageKey))
              .catch(err => console.error("Error saving updated docs:", err));
          }
    
      
          return updatedDocs;
        });
        };

        fetchAndUpdateDocs();
        fetchDocuments();
      }, [
        compliantLetter,
        corporateStructureData,
        managementUboState,
        landRegisterCopy,
        BillingRecognized,
        RegulatoryListed,
        transactionStatus,
        eddFormData,
        isPEP,
        InfluenceTransaction
     
      ]);
        



    const openDocumentModal = async (docType, fileObj = null) => {
        // Multi-file: use cached blob_url directly
        if (fileObj) {
          setPreviewFile(fileObj);
          setCurrentDocType(docType);
          setPreviewModalOpen(false);
          setTimeout(() => setPreviewModalOpen(true), 100);
          return;
        }
        setPreviewFile(null);

        console.log("📂 Opening document:", docType);
        const { entityId, requestId, email } = getStoredValues();
        // console.log("docType in openDocument:", docType);
      
        // 🔍 Only modify docType if we're on FinalReview page
        let cleanedDocType = docType;
        // if (currentPage === "/FinalReview") {
        //   const locations = ["/transaction-detail", "/Edd", "/client-counter", "/corporate-structure", "/management-structure","/RiskAsses"];
        //   for (const loc of locations) {
        //     const prefix = loc.substring(1); // remove leading '/'
        //     if (docType.startsWith(`${prefix}-`)) {
        //       cleanedDocType = docType.replace(`${prefix}-`, ""); // 🧼 Remove prefix
        //       break;
        //     }
        //   }
        // }
      
        try {
          const encodedDocType = encodeURIComponent(cleanedDocType); // ✅ Encode if needed
      
          // const response = await axios.get(`${config['backend-url']}/get-document-url`, {
          //   params: { docType: cleanedDocType, entityId, requestId, email }
          // });



          const response = await axios.get(`${config['backend-url']}/get-document-url`, {
            params: { docType: cleanedDocType, entityId, requestId, email },
            headers: {
              Authorization: `Bearer ${userSession.getToken()}`, // Use token from userSession
            }
          });
      
          // console.log("response in openDocument:", response);
      
          if (response.status === 200 && response.data?.blob_url) {
            // console.log("📂 Received blob_url:", response.data.blob_url);
      
            // 🛡️ Safely update optionalAttachments if docType exists there
            if (optionalAttachments.hasOwnProperty(docType)) {
              // console.log("📂 Updating optionalAttachments");
      
              setOptionalAttachments((prevOptional) => ({
                ...prevOptional,
                [docType]: {
                  ...(prevOptional[docType] || {}),  // ✅ Safe spreading
                  file: response.data.blob_url,
                },
              }));
            } else {
              console.log("📂 Updating required documents");
      
              setDocuments((prevDocs) => ({
                ...prevDocs,
                [docType]: {
                  ...(prevDocs[docType] || {}),  // ✅ Safe spreading
                  file: response.data.blob_url,
                },
              }));
            }
      
            // ⚡ Refresh Preview Modal
            setCurrentDocType(docType); // Store which docType we are previewing
            setPreviewModalOpen(false); 
            setTimeout(() => setPreviewModalOpen(true), 100);
          } else {
            console.error("❌ Failed to open document URL. Response:", response);
          }
        } catch (error) {
          console.error("❌ Error opening updated document URL:", error);
        }
      };
      
      
      const fetchDocuments = async () => {
        try {
          const pageName = window.location.pathname;
          const { entityId, requestId, email } = getStoredValues();
          // console.log("🔍 Fetching email for:", pageName, email, entityId, requestId);
      
          let responses = [];
          const pageKey = pageName.substring(1); // Remove leading "/"
    
      
          const response = await axios.get(`${config['backend-url']}/documents`, {
            params: { page_name: pageName, entityId, requestId, email },

            headers: {
              Authorization: `Bearer ${userSession.getToken()}`, // Use token from userSession
            }
          });
          // console.log("response:",response)
    
          if (response.status === 200 && Array.isArray(response.data)) {
            responses = response.data.map(doc => {
              // if (pageName === "/FinalReview" && doc.is_optional === false) {
              //   // ✅ Only modify document_type if on FinalReview page
              //   // const pageKeyFromDoc = doc.page_name?.startsWith("/") ? doc.page_name.substring(1) : doc.page_name || "unknown";
              //   return {
              //     ...doc,
              //     // document_type: `${pageKeyFromDoc}-${doc.document_type}`
              //   };
              // } else {
              //   // ✅ On other pages, keep document_type same
              //   return { ...doc };
              // }
              return { ...doc };
            });
          }
    
      
          // Process the responses
          const loadedDocs = {};
          responses.forEach(doc => {
            const docData = {
              filename: doc.filename,
              file: doc.blob_url,
              description: doc.description || "No description available",
              entityId: doc.entityId,
              requestId: doc.requestId,
              email: doc.email,
              certified: doc.certified || false,
              page_name: doc.page_name,
              is_optional: doc.is_optional || false
            };
            if (MULTI_FILE_DOC_TYPES.includes(doc.document_type)) {
              if (!Array.isArray(loadedDocs[doc.document_type])) {
                loadedDocs[doc.document_type] = [];
              }
              loadedDocs[doc.document_type].push(docData);
            } else {
              loadedDocs[doc.document_type] = docData;
            }
          });
      
          console.log("✅ Fetched Documents:", loadedDocs);
      
          setDocuments(prevDocs => {
            let updatedPrevDocs = { ...prevDocs };
          
            if (pageName === "/FinalReview") {
              // Clean up previous docs if they exist
              Object.keys(loadedDocs).forEach(key => {
                if (updatedPrevDocs.hasOwnProperty(key)) {
                  delete updatedPrevDocs[key];
                }
              });
            }
          
            const newDocs = {
              ...updatedPrevDocs,
              ...loadedDocs,
            };
          
            // Split loadedDocs into Required and Optional based on 'is_optional' flag
            const requiredDocs = {};
            const optionalDocs = {};
          
            for (const [docType, docData] of Object.entries(newDocs)) {
              if (docData?.is_optional) {
                optionalDocs[docType] = docData;
              } else {
                requiredDocs[docType] = docData;
              }
            }
            // ✅ Save document types to localStorage
            const docTypes = Object.keys(loadedDocs);
            localStorage.setItem("loadedDocs", JSON.stringify(docTypes));
          
            // ✅ Save full doc data in 'detailedDocs'
            const docList = Object.entries(loadedDocs)
            .filter(([docType, docData]) => {
              const isOptionalByName = docType.includes("Optional");
              const isOptionalFlag = Array.isArray(docData) ? false : docData?.is_optional;
              return !isOptionalByName && !isOptionalFlag; // Keep only required docs
            })
            .flatMap(([docType, docData]) => {
              if (Array.isArray(docData)) {
                return docData.map(d => ({ docType, ...d }));
              }
              return [{ docType, ...docData }];
            });
          
            localStorage.setItem("detailedDocs", JSON.stringify(docList));
            // console.log(localStorage)
          
            // Update the separate states for required and optional
            setOptionalAttachments(prevOptionalAttachments => ({
              ...prevOptionalAttachments,
              ...optionalDocs
            }));
            
            return requiredDocs;
          });      
      
        } catch (error) {
          console.error("❌ Error fetching documents:", error);
          setDocuments({});
        }
      };
      
      
      useEffect(() => {
        fetchDocuments();
      }, []);
      
      
    
    const deleteDocument = async (docKey,docType) => {
        try {
            const latestStatus = await fetchRequestStatus();

            if (!latestStatus) {
              console.warn("⚠️ Could not determine status. Blocking Delete.");
              return;
            }

            if (["complete", "finalized", "deleted"].includes(latestStatus)) {
              console.warn("⛔ Delete is disabled. Status:", latestStatus);
              return;
            }
            if (!docKey) {
                console.error("❌ Error: Missing filename");
                return;
            }
            
            // Extract page name from docType
            // const pageNameList = [
            //   "/transaction-detail", "/property-info", "/client-counter",
            //   "/corporate-structure", "/management-structure", "/RiskAsses",
            //   "/Edd", "/FinalReview", "/Report"
            // ];
    
            // const docPrefix = docType?.split("-")[0]; // e.g., "management-structure"
            // const matchedPageName = pageNameList.find(p => p.includes(docPrefix)) || currentPage;
    
            const { entityId, requestId, email } = getStoredValues();
            const filename = docKey; 

             let matchedPageName = currentPage;

            // 🔍 Only apply detection if we're on FinalReview
            if (currentPage === "/FinalReview") {
              const originalDocType = docType;
              let tempDocType = originalDocType;

              // Strip entity prefix like "Ubo 1 -", "Manager 2 -"
              // const stripEntityPrefix = (docType) => {
              //   const entityPrefixes = ["UBO", "Manager"];
              //   for (let prefix of entityPrefixes) {
              //     const regex = new RegExp(`^${prefix} \\d+ - `, 'i');
              //     if (regex.test(docType)) {
              //       return docType.replace(regex, '');
              //     }
              //   }
              //   return docType;
              // };
              const stripEntityPrefix = (docType) => {
                // Handles up to two nested prefixes
                const entityPrefixPattern = /^(UBO|Manager)( \d+)?( - Director \d+)? - /i;
                return docType.replace(entityPrefixPattern, '').trim();
              };
              // Detect if the document is associated with UBO or Manager
              const getEntityFlags = (docType) => {
                // const isUBO = /^UBO( \d+)? - /i.test(docType);         // Matches "UBO 1 - ..." or "UBO - ..."
                // const isManager = /^Manager( \d+)? - /i.test(docType); // Matches "Manager 2 - ..." or "Manager - ..."
                const isUBO = /^UBO( \d+)?( - Director \d+)? - /i.test(docType);
                const isManager = /^Manager( \d+)?( - Director \d+)? - /i.test(docType);

                return { isUBO, isManager };
              };

              const { isUBO, isManager } = getEntityFlags(originalDocType);
              tempDocType = stripEntityPrefix(tempDocType);

              for (const [page, docTypes] of Object.entries(docTypeConfig)) {
                if (docTypes.includes(tempDocType)) {
                  // Force override if it's an entity
                  if (isUBO) {
                    matchedPageName = "/corporate-structure";
                    // console.log("📌 Forced match (UBO):", matchedPageName);
                    break;
                  }
                  if (isManager) {
                    matchedPageName = "/management-structure";
                    // console.log("📌 Forced match (Manager):", matchedPageName);
                    break;
                  }

                  // Default to matched page if no entity-specific override
                  matchedPageName = page;
                  console.log("✅ Matched from config:", matchedPageName);
                  break;
                }
              }
            }
    
            const response = await axios.delete(`${config['backend-url']}/delete`, {
                headers: { 
                  "Authorization": `Bearer ${userSession.getToken()}`, // Use token from userSession
                  
                  "Content-Type": "application/json" },
                data: { 
                    filename: filename,
                    page_name: matchedPageName,
                    entityId: entityId,
                    requestId: requestId,
                    email: email
                },
            });
    
            if (response.status === 200) {
                console.log("✅ File deleted successfully:", response.data.message);
                setModalMessage(<DocumentDeleted />);
                // setIsModalOpen(true);
                window.location.reload(); 
                setModalOpen(false);
    
                if (typeof setRefreshDocs === 'function') {
                  setRefreshDocs(prev => !prev);
                } else {
                  console.warn("⚠️ setRefreshDocs is not a function");
                }
    
                // ✅ Only remove the file reference, keep other details
                setDocuments((prevDocs) => {
                    const updatedDocs = { ...prevDocs };

                    // Find the document type associated with the deleted file
                    Object.keys(updatedDocs).forEach((key) => {
                        if (Array.isArray(updatedDocs[key])) {
                            // Multi-file: filter out the deleted file
                            updatedDocs[key] = updatedDocs[key].filter(f => f.filename !== filename);
                        } else if (updatedDocs[key]?.filename === filename) {
                            updatedDocs[key] = {
                                ...updatedDocs[key],
                                file: null,  // ❌ Remove only the file
                                filename: null // ❌ Remove filename but keep metadata
                            };
                        }
                    });

                    return { ...updatedDocs }; // ✅ Ensure state updates properly
                });
    
            }
        } catch (error) {
            console.error("❌ Delete error:", error.response?.data || error);
            setModalMessage(<DeletionFailed />);
            setIsModalOpen(true);
        }
    };

        return {
            currentPage,
            modalOpen,
            setModalOpen,
            modalMessage,
            setModalMessage,
            documents,
            setDocuments,
            certifiedCheckbox,
            setCertifiedCheckbox,
            optionalAttachments,
            setOptionalAttachments,
            optionalCount,
            setOptionalCount,
            uploadingToOptional,
            setUploadingToOptional,
            uploadModalOpen,
            setUploadModalOpen,
            previewModalOpen,
            setPreviewModalOpen,
            previewFile,
            setPreviewFile,
            currentDocType,
            setCurrentDocType,
            file,
            setFile,
            dragging,
            setDragging,
            modalRef,
            addOptionalAttachment,
            handleDeleteOptionalAttachment,
            openUploadModal,
            handleFileChange,
            handleDragOver,
            handleDragLeave,
            handleDrop,
            fileDescriptions,
            handleDescriptionChange,
            uboTypeDocuments,
            trusteeTypeDocuments,
            updateDocumentsForType,
            
            fetchDocuments,
            openDocumentModal,
            handleFileUpload,
            deleteDocument,
            setFileDescriptions,
            modalHeading,
            setIsModalOpen,
            isModalOpen,
            modalHeading,
            fileName,
            setFileName,
            status,
            setStatus
        };
    };